import getAPI from "@API/index";

export const deleteFinDataRequest = (id) => {
  return (dispatch) => {
    let request;
    if (Array.isArray(id)) {
      request = getAPI().request({
        method: "delete",
        url: `/api/FinDataRequest`,
        data: id,
      });
    } else {
      request = getAPI().request({
        method: "delete",
        url: `/api/FinDataRequest/${id}`,
      });
    }
    request.then(() => {
      window.location.reload();
    });
  };
};
